import { css } from "theme/default/css";

export const setFlexF1 = css`
  flex: 1;
`;
